// src/components/routes/AppRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Page Components
import Insights from '../pages/Insights';
import TryNow from '../pages/tryNow/TryNow';

// Listing Components
import PCSApiList from '../listings/PCSApiList';
import AccountsList from '../listings/AccountsList';
import ServiceTypesList from '../listings/ServiceTypesList';
import PricingTypesList from '../listings/PricingTypesList';
import UsersList from '../listings/UsersList';
import VerifyEmail from '../pages/VerifyEmail/VerifyEmail';
import PublicRoute from '../publicRoute/PublicRoute';
import LandingLayout from '../landingLayout/LandingLayout';
import OurProducts from '../pages/ourProducts/OurProducts';
import Industry from '../pages/industry/Industry';
import LoginLayout from '../pages/login/LoginLayout';
import RegisterLayout from '../pages/register/RegisterLayout';
import SalesQuery from '../pages/salesQuery/SalesQuery';
import About from '../pages/about/About';
import ForgetEmailVerification from '../pages/ForgotPassword/ForgetEmailVerification/ForgetEmailVerification';
import PasswordConfirm from '../pages/ForgotPassword/PasswordConfirm/PasswordConfirm';
import ConfirmEmail from '../pages/ConfirmEmail/ConfirmEmail';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Pages - Only accessible when NOT logged in */}
      <Route
        path="/"
        element={
          <PublicRoute redirectTo="/products">
            <LandingLayout />
          </PublicRoute>
        }
      />
      <Route
        path="/industries"
        element={
          <PublicRoute redirectTo="/products">
            <Industry />
          </PublicRoute>
        }
      />
      <Route
        path="/about"
        element={
          <PublicRoute redirectTo="/products">
            <About />
          </PublicRoute>
        }
      />

      {/* Authentication Routes - Only accessible when NOT logged in */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginLayout />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <RegisterLayout />
          </PublicRoute>
        }
      />
      <Route
        path="/verify-email"
        element={
          <PublicRoute>
            <VerifyEmail />
          </PublicRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <ForgetEmailVerification />
          </PublicRoute>
        }
      />
      <Route
        path="/confirm-password"
        element={
          <PublicRoute>
            <PasswordConfirm />
          </PublicRoute>
        }
      />
      <Route
        path="/confirm-email"
        element={
          <PublicRoute>
            <ConfirmEmail />
          </PublicRoute>
        }
      />

      {/* Accessible to both authenticated and unauthenticated users */}
      <Route path="/products" element={<OurProducts />} />
      <Route path="/try/:productId" element={<TryNow />} />

      {/* Protected Routes - Blocked when logged in */}
      <Route
        path="/sales-query"
        element={
          <PublicRoute redirectTo="/products">
            <SalesQuery />
          </PublicRoute>
        }
      />

      {/* Listing Routes - Blocked when logged in */}
      {/* <Route path="/pcs-api" element={<PCSApiList />} /> */}
      <Route
        path="/accounts"
        element={
          <PublicRoute redirectTo="/products">
            <AccountsList />
          </PublicRoute>
        }
      />
      <Route
        path="/service-types"
        element={
          <PublicRoute redirectTo="/products">
            <ServiceTypesList />
          </PublicRoute>
        }
      />
      <Route
        path="/pricing-types"
        element={
          <PublicRoute redirectTo="/products">
            <PricingTypesList />
          </PublicRoute>
        }
      />
      <Route
        path="/users"
        element={
          <PublicRoute redirectTo="/products">
            <UsersList />
          </PublicRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
